import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getSearch } from 'selectors';
import { useEffectOnce } from 'common/hooks';
import { getQueryParam, getTopCategoriesId, loadSessionStorageState, sortListWithIds } from 'utils';
import { selectTopCategories } from '../../../selectors';
import { sliceKey } from '../slice';
import { useCatalogueContentSlice } from './use-catalogue-content-slice';

export const useCatalogueContent = () => {
	const { setSelectedFilterItems } = useCatalogueContentSlice();

	const searchParams = useSelector(getSearch);
	const topCategories = useSelector(selectTopCategories);

	const setSelectedFI = useCallback(
		(newSelectedItems: number[]) =>
			setSelectedFilterItems({ selectedFilterItems: newSelectedItems }),
		[setSelectedFilterItems]
	);

	useEffectOnce(() => {
		if (searchParams) {
			const { selectedFilterItems } = getQueryParam(searchParams, ['selectedFilterItems']);

			if (selectedFilterItems) {
				let result;
				if (selectedFilterItems.indexOf(',')) {
					result = selectedFilterItems.split(',').map(id => Number(id));
				} else {
					result = [Number(selectedFilterItems)];
				}

				const topCategoriesId = getTopCategoriesId(topCategories);

				result = result.filter(searchId => topCategoriesId.includes(searchId));

				if (result.length) {
					result = sortListWithIds(result, topCategories);
					setSelectedFI(result);
				}
			}
		} else if (!__IS_SERVER__) {
			const sessionStorageItemKey = `${sliceKey}_selectedFilterItems`;
			setSelectedFI(loadSessionStorageState(sessionStorageItemKey) || []);
		}
	});
};
